
 

 

 

    import AuditLogSearchCriteria from 'Modules/Core/Scripts/AuditLogSearchCriteria';

    import PagingCriteria from 'Lib/Fs.Core.Data/PagingCriteria';

 
class AuditLogSearchParameter 
{
    
        Criteria: AuditLogSearchCriteria;
    
        SortingCriteria: any;
    
        PagingCriteria: PagingCriteria;
    
}
 
export default AuditLogSearchParameter;
 




